var __templateData = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (continueBtnText, doneText, game, hasNarration, hasPrompt, i18n, klass, metadata, prompt, submitUp, title, undefined) {
if ( game && game.timer && game.timer.limit > 0 && !game.timer.isDisabled)
{
buf.push("<div class=\"full-screen\"><div class=\"game-stepper text-lg text-bold\"></div><div class=\"game-progress\"><div class=\"game-progress-bar\"></div></div></div>");
}
jade_mixins["image"] = jade_interp = function(imageUrl, klass){
var block = (this && this.block), attributes = (this && this.attributes) || {};
buf.push("<img" + (jade.attr("src", imageUrl, true, false)) + (jade.cls([klass], [true])) + "/>");
};
buf.push("<div class=\"content-fill\"><div class=\"block-v-md content-fill content-sm-ver content-md-ver\"><div class=\"row content-fill content-area text-center\"><div class=\"col-sm-12 col-lg-6 content-lg-ver\"><h1 class=\"title tight block-v-md\">" + (null == (jade_interp = title) ? "" : jade_interp) + "</h1></div><div class=\"col-sm-12 col-lg-6\">");
// iterate metadata.questions
;(function(){
  var $$obj = metadata.questions;
  if ('number' == typeof $$obj.length) {

    for (var j = 0, $$l = $$obj.length; j < $$l; j++) {
      var pair = $$obj[j];

var question = pair.question;
var answers = pair.answers;
buf.push("<div class=\"row\">");
// iterate _.shuffle(pair.answers)
;(function(){
  var $$obj = _.shuffle(pair.answers);
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var answer = $$obj[i];

klass  = answer.correct ? "correct" : "incorrect"
klass += i === 0 ? " left" : " right"
buf.push("<div class=\"col-sm-6 block-v-sm slide-up hide-overflow block-box-sizing\"><div" + (jade.attr("data-correct", answer.correct, true, false)) + (jade.attr("data-content", answer.content, true, false)) + (jade.attr("data-answer-id", answer.id, true, false)) + (jade.attr("data-question-id", question.id, true, false)) + (jade.attr("data-group", j, true, false)) + (jade.attr("data-image", i, true, false)) + (jade.cls(['image-container','block-dk','block-sm','content-fill',klass], [null,null,null,null,true])) + ">");
jade_mixins["image"](answer.content, 'img content-ver block');
buf.push("</div></div>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var answer = $$obj[i];

klass  = answer.correct ? "correct" : "incorrect"
klass += i === 0 ? " left" : " right"
buf.push("<div class=\"col-sm-6 block-v-sm slide-up hide-overflow block-box-sizing\"><div" + (jade.attr("data-correct", answer.correct, true, false)) + (jade.attr("data-content", answer.content, true, false)) + (jade.attr("data-answer-id", answer.id, true, false)) + (jade.attr("data-question-id", question.id, true, false)) + (jade.attr("data-group", j, true, false)) + (jade.attr("data-image", i, true, false)) + (jade.cls(['image-container','block-dk','block-sm','content-fill',klass], [null,null,null,null,true])) + ">");
jade_mixins["image"](answer.content, 'img content-ver block');
buf.push("</div></div>");
    }

  }
}).call(this);

buf.push("</div>");
    }

  } else {
    var $$l = 0;
    for (var j in $$obj) {
      $$l++;      var pair = $$obj[j];

var question = pair.question;
var answers = pair.answers;
buf.push("<div class=\"row\">");
// iterate _.shuffle(pair.answers)
;(function(){
  var $$obj = _.shuffle(pair.answers);
  if ('number' == typeof $$obj.length) {

    for (var i = 0, $$l = $$obj.length; i < $$l; i++) {
      var answer = $$obj[i];

klass  = answer.correct ? "correct" : "incorrect"
klass += i === 0 ? " left" : " right"
buf.push("<div class=\"col-sm-6 block-v-sm slide-up hide-overflow block-box-sizing\"><div" + (jade.attr("data-correct", answer.correct, true, false)) + (jade.attr("data-content", answer.content, true, false)) + (jade.attr("data-answer-id", answer.id, true, false)) + (jade.attr("data-question-id", question.id, true, false)) + (jade.attr("data-group", j, true, false)) + (jade.attr("data-image", i, true, false)) + (jade.cls(['image-container','block-dk','block-sm','content-fill',klass], [null,null,null,null,true])) + ">");
jade_mixins["image"](answer.content, 'img content-ver block');
buf.push("</div></div>");
    }

  } else {
    var $$l = 0;
    for (var i in $$obj) {
      $$l++;      var answer = $$obj[i];

klass  = answer.correct ? "correct" : "incorrect"
klass += i === 0 ? " left" : " right"
buf.push("<div class=\"col-sm-6 block-v-sm slide-up hide-overflow block-box-sizing\"><div" + (jade.attr("data-correct", answer.correct, true, false)) + (jade.attr("data-content", answer.content, true, false)) + (jade.attr("data-answer-id", answer.id, true, false)) + (jade.attr("data-question-id", question.id, true, false)) + (jade.attr("data-group", j, true, false)) + (jade.attr("data-image", i, true, false)) + (jade.cls(['image-container','block-dk','block-sm','content-fill',klass], [null,null,null,null,true])) + ">");
jade_mixins["image"](answer.content, 'img content-ver block');
buf.push("</div></div>");
    }

  }
}).call(this);

buf.push("</div>");
    }

  }
}).call(this);

buf.push("</div></div></div></div><div" + (jade.cls(['slide-footer','block-v-lg',submitUp ? "slide-footer--up slide-down" : "slide-up"], [null,null,true])) + ">");
if ( hasPrompt)
{
buf.push("<div class=\"slide-footer-touched\"><div class=\"btn btn-muted btn-done text-ellipsis\">" + (null == (jade_interp = doneText) ? "" : jade_interp) + "</div></div>");
if ( typeof prompt === "string")
{
buf.push("<div class=\"slide-footer-prompt text-uppercase text-bold\"><div class=\"slide-footer-prompt-content content-ver\">" + (null == (jade_interp = prompt) ? "" : jade_interp) + "</div></div>");
}
}
else
{
buf.push("<div class=\"slide-footer-prompt\"><div class=\"btn btn-muted btn-done text-ellipsis content-ver\">" + (null == (jade_interp = continueBtnText || i18n("buttons.continue")) ? "" : jade_interp) + "</div></div>");
}
if ( hasNarration)
{
buf.push("<div class=\"slide-footer-narration\"><div class=\"narration-progress btn btn-muted\"><div class=\"narration-progress-bar\"></div><div class=\"wave-ellipse\"><span class=\"bullet delay-1 block-inline\">&bullet;</span><span class=\"bullet delay-2 block-inline\">&bullet;</span><span class=\"bullet delay-3 block-inline\">&bullet;</span></div></div></div>");
}
buf.push("</div>");}.call(this,"continueBtnText" in locals_for_with?locals_for_with.continueBtnText:typeof continueBtnText!=="undefined"?continueBtnText:undefined,"doneText" in locals_for_with?locals_for_with.doneText:typeof doneText!=="undefined"?doneText:undefined,"game" in locals_for_with?locals_for_with.game:typeof game!=="undefined"?game:undefined,"hasNarration" in locals_for_with?locals_for_with.hasNarration:typeof hasNarration!=="undefined"?hasNarration:undefined,"hasPrompt" in locals_for_with?locals_for_with.hasPrompt:typeof hasPrompt!=="undefined"?hasPrompt:undefined,"i18n" in locals_for_with?locals_for_with.i18n:typeof i18n!=="undefined"?i18n:undefined,"klass" in locals_for_with?locals_for_with.klass:typeof klass!=="undefined"?klass:undefined,"metadata" in locals_for_with?locals_for_with.metadata:typeof metadata!=="undefined"?metadata:undefined,"prompt" in locals_for_with?locals_for_with.prompt:typeof prompt!=="undefined"?prompt:undefined,"submitUp" in locals_for_with?locals_for_with.submitUp:typeof submitUp!=="undefined"?submitUp:undefined,"title" in locals_for_with?locals_for_with.title:typeof title!=="undefined"?title:undefined,"undefined" in locals_for_with?locals_for_with.undefined:typeof undefined!=="undefined"?undefined:undefined));;return buf.join("");
};
if (typeof define === 'function' && define.amd) {
  define([], function() {
    return __templateData;
  });
} else if (typeof module === 'object' && module && module.exports) {
  module.exports = __templateData;
} else {
  __templateData;
}